module.exports = __webpack_public_path__ + "img/logo.d390bb7e.png";